/*
 * crioh-card-swatches.js
 * Filas de miniaturas de color en tarjeta (.crioh-swatch-row, solo-preview):
 * mantiene UNA sola fila, oculta lo que no cabe y muestra un "+N" (enlace a la
 * ficha) con el número de ocultos. Recalcula con ResizeObserver (ancho/responsive),
 * IntersectionObserver (tarjetas fuera de pantalla) y MutationObserver (scroll
 * infinito / re-render).
 */
(function () {
  if (window.__criohCardSwatches) return;
  window.__criohCardSwatches = true;

  /* ── Preview robusto de miniatura (hover / tap) ──────────────────────────
     slideshow.select({id}) NO puede ir a un slide 'hidden', y card-gallery.liquid
     renderiza las imágenes de variante ocultas salvo la primera. Por eso, en
     productos "todo imágenes de variante", el preview no llegaba a las demás.
     Solución: des-ocultar el slide destino (y ocultar el resto) antes de select,
     igual que hace la selección nativa de variante. En el reset restauramos el
     estado inicial de visibilidad y volvemos al primer slide.
     Lo gestionamos aquí (y no con on: declarativo) para poder des-ocultar antes
     de seleccionar y evitar conflictos de doble manejo en el reset. */
  function criohCtx(el) {
    var card = el && el.closest ? el.closest('product-card') : null;
    if (!card) return null;
    var ss = (card.refs && card.refs.slideshow) || card.querySelector('slideshow-component');
    if (!ss || !ss.refs || !ss.refs.slides || !ss.refs.slides.length) return null;
    return { card: card, ss: ss, slides: ss.refs.slides };
  }

  function criohPreview(ctx, id) {
    if (!id) return;
    if (!ctx.card.__criohInitHidden) {
      ctx.card.__criohInitHidden = ctx.slides.map(function (s) {
        return !!s.hidden;
      });
    }
    var found = false;
    ctx.slides.forEach(function (s) {
      var match = s.getAttribute('slide-id') === id;
      if (match) found = true;
      s.hidden = !match;
    });
    if (found) {
      try {
        ctx.ss.select({ id: id }, undefined, { animate: false });
      } catch (e) {}
    }
  }

  function criohReset(ctx) {
    var init = ctx.card.__criohInitHidden;
    if (init) {
      ctx.slides.forEach(function (s, i) {
        s.hidden = init[i];
      });
    }
    var first = null;
    for (var i = 0; i < ctx.slides.length; i++) {
      if (!ctx.slides[i].hidden) {
        first = ctx.slides[i];
        break;
      }
    }
    var fid = first && first.getAttribute('slide-id');
    if (fid) {
      try {
        ctx.ss.select({ id: fid }, undefined, { animate: false });
      } catch (e) {}
    }
  }

  function criohSwatch(target) {
    return target && target.closest ? target.closest('.crioh-cswatch') : null;
  }

  // pointerenter/leave no burbujean → escuchamos en fase de captura (como el tema).
  document.addEventListener(
    'pointerenter',
    function (e) {
      var b = criohSwatch(e.target);
      if (!b) return;
      var ctx = criohCtx(b);
      if (ctx) criohPreview(ctx, b.getAttribute('data-media-id'));
    },
    true
  );
  document.addEventListener(
    'pointerleave',
    function (e) {
      var b = criohSwatch(e.target);
      if (!b) return;
      var ctx = criohCtx(b);
      if (ctx) criohReset(ctx);
    },
    true
  );
  // Tap/click: preview (queda fijado hasta tocar otra) — funciona en móvil.
  document.addEventListener('click', function (e) {
    var b = criohSwatch(e.target);
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var ctx = criohCtx(b);
    if (ctx) criohPreview(ctx, b.getAttribute('data-media-id'));
  });

  function layoutRow(row) {
    if (!row) return;
    var list = row.querySelector('.crioh-swatch-row__list');
    var more = row.querySelector('.crioh-swatch-row__more');
    if (!list || !more) return;

    var items = Array.prototype.slice.call(list.children);
    if (!items.length) return;

    for (var i = 0; i < items.length; i++) items[i].style.display = '';
    more.hidden = true;

    var rowWidth = list.clientWidth;
    if (!rowWidth) return;

    // Ya tenemos una medida válida: la fila puede revelarse (anti-FOUC).
    row.setAttribute('data-crioh-ready', '');

    var styles = getComputedStyle(list);
    var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;

    var total = 0;
    for (var t = 0; t < items.length; t++) {
      total += items[t].offsetWidth + (t > 0 ? gap : 0);
    }
    if (total <= rowWidth + 1) {
      more.hidden = true;
      return;
    }

    more.hidden = false;
    more.textContent = '+00';
    var moreWidth = more.offsetWidth + gap;

    var used = 0;
    var shown = 0;
    for (var j = 0; j < items.length; j++) {
      var w = items[j].offsetWidth + (j > 0 ? gap : 0);
      if (used + w + moreWidth <= rowWidth) {
        used += w;
        shown++;
      } else {
        break;
      }
    }
    if (shown < 1) shown = 1;

    var hidden = 0;
    for (var k = 0; k < items.length; k++) {
      if (k >= shown) {
        items[k].style.display = 'none';
        hidden++;
      }
    }

    if (hidden > 0) {
      more.textContent = '+' + hidden;
      more.hidden = false;
    } else {
      more.hidden = true;
    }
  }

  var hasRO = typeof ResizeObserver !== 'undefined';
  var hasIO = typeof IntersectionObserver !== 'undefined';

  var ro = hasRO
    ? new ResizeObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var el = entries[i].target;
          layoutRow(el.closest ? el.closest('[data-crioh-swatch-row]') || el : el);
        }
      })
    : null;

  var io = hasIO
    ? new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) layoutRow(entries[i].target);
          }
        },
        { rootMargin: '300px' }
      )
    : null;

  function register(row) {
    if (row.__criohReg) return;
    row.__criohReg = true;
    layoutRow(row);
    if (ro) {
      var list = row.querySelector('.crioh-swatch-row__list');
      if (list) ro.observe(list);
    }
    if (io) io.observe(row);
    if (!ro && !io) {
      window.addEventListener('resize', function () {
        layoutRow(row);
      });
    }
  }

  function scanAll() {
    var rows = document.querySelectorAll('[data-crioh-swatch-row]');
    for (var i = 0; i < rows.length; i++) register(rows[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanAll);
  } else {
    scanAll();
  }
  window.addEventListener('load', scanAll);

  // Failsafe: si alguna fila no se llegó a medir (p.ej. estaba display:none),
  // revelarla igualmente pasado un momento para no dejarla oculta indefinidamente.
  setTimeout(function () {
    var rows = document.querySelectorAll('[data-crioh-swatch-row]:not([data-crioh-ready])');
    for (var i = 0; i < rows.length; i++) rows[i].setAttribute('data-crioh-ready', '');
  }, 2500);

  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
        scanAll();
        return;
      }
    }
  });
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });
})();
